import { useSessionNotification } from '../../../utils/actionableNotifications';
import React from 'react';

import { SafetyCertificateFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AppTheme from '../../../components/theme/AppTheme';
import { useQuarantineNotifications } from '../viewmodels/useQuarantineNotifications';
export default function QuarantineNotifications() {
  const [notices, holder] = useSessionNotification();
  const navigate = useNavigate();
  useQuarantineNotifications({ show: item => notices.warning({ ...item, icon: <SafetyCertificateFilled /> }), dismiss: notices.destroy,
    open: conversationId => navigate('/querysetv4', { state: { openChatId: conversationId } }) });
  return <AppTheme>{holder}</AppTheme>;
}
